import { render } from "./add_product.vue?vue&type=template&id=745028b0"
import script from "./add_product.vue?vue&type=script&lang=js"
export * from "./add_product.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__